import { computed, inject } from 'vue';
import I18n from 'i18n-js';

export default function useOrganisationProfile() {
  const currentOrganisation = inject('currentOrganisation');
  const isAga = computed(() => currentOrganisation.value?.aga_profile === true);

  function priorityLabel(priority) {
    const scope = isAga.value ? 'aga_priority_labels' : 'priority_labels';

    return I18n.t(`${scope}.${priority}`);
  }

  function inspectionTypeName(type) {
    const name = I18n.t(`inspection_types.${type}.name`);

    return isAga.value ? I18n.t(`aga_inspection_type_names.${type}`, { defaultValue: name }) : name;
  }

  return {
    showRisk: computed(() => {
      if (currentOrganisation.value) {
        return !currentOrganisation.value.aga_profile;
      } else {
        return false;
      }
    }),
    isAga,
    priorityLabel,
    inspectionTypeName,
    profileLoaded: computed(() => !!currentOrganisation?.value),
  };
}
